/**
 * Returns true when the current page is running in AEM authoring or disabled wcmmode.
 */
export function isAemPage(): boolean {
  return Boolean(window.Mhecomm_Editor) || new URL(window.location.href).searchParams.get('wcmmode') === 'disabled';
}
